import type { CompanionPageId } from '@fluenceur/types';
import { matchPath } from 'react-router-dom';

/**
 * Which page the Companion is reading. The backend gives the agent the tools of
 * that page and nothing more, so the table is closed: a route it does not name
 * is `other`, never a guess from a neighbour.
 */
const PAGE_ROUTES: ReadonlyArray<readonly [pattern: string, page: CompanionPageId]> = [
  ['/dashboard', 'dashboard'],
  ['/collabs/suivi', 'collabs_tracking'],
  ['/collabs', 'copublicity'],
  ['/collabs/ugc', 'ugc'],
  ['/collabs/brief-templates/*', 'brief_templates'],
  ['/applications', 'applications'],
  ['/gifting', 'gifting'],
  ['/affiliates/*', 'affiliates'],
  ['/programs/*', 'programs'],
  ['/mentions', 'mentions'],
  ['/creators/discovery', 'discovery'],
  ['/flows', 'flows'],
];

export const companionPageForPath = (pathname: string): CompanionPageId =>
  PAGE_ROUTES.find(([pattern]) => matchPath(pattern, pathname))?.[1] ?? 'other';

/**
 * The sidebar pages the Companion reads as `other`, named in the composer as
 * the sidebar names them. They change nothing about the tools: only the chip.
 */
const OTHER_PAGE_NAME_KEYS: ReadonlyArray<readonly [pattern: string, key: string]> = [
  ['/messages/*', 'navigation.inbox'],
  ['/payments/*', 'navigation.commissions'],
  ['/brand-space/*', 'navigation.brandSpace'],
  ['/settings/*', 'navigation.settings'],
];

export const otherPageNameKey = (pathname: string): string | null =>
  OTHER_PAGE_NAME_KEYS.find(([pattern]) => matchPath(pattern, pathname))?.[1] ?? null;
